import { html, LitElement } from "lit";
import { customElement, property } from 'lit/decorators.js';
import { localized, msg, str } from '@lit/localize';
import { when } from "lit/directives/when.js";
import style from './menu-top.scss';
import "./menu-top-hamburger";

/**
 * Top menu component. Contains left menu collapse button.
 *
 * @slot - top menu items
 */
@customElement('menu-top')
@localized()
export class MenuTop extends LitElement {
    static override shadowRootOptions = { ...LitElement.shadowRootOptions, delegatesFocus: true };
    static override styles = style;

    /** Should hamburger not be rendered? */
    @property({type: Boolean, attribute: 'no-hamburger'}) noHamburger = false;

    override connectedCallback(): void {
        super.connectedCallback();
        this.tabIndex = 0;
    }

    override render() {
        return html`
            <div id="menuTop" role="navigation" aria-label="${msg(str`Menu główne`)}">
                ${when(!this.noHamburger, () => html`<menu-top-hamburger style="font-size: 1rem;"></menu-top-hamburger>`)}
                <div id="ul" role="list">
                    <slot></slot>
                </div>
            </div>
        `;
    }

}



declare global {
    interface HTMLElementTagNameMap {
      "menu-top": MenuTop,
    }
}
